<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-container-padding-mobile backdrop-blur-sm md:p-container-padding-desktop"
>
  <div class="glass-panel flex w-full max-w-sm flex-col items-center gap-bento-gap rounded-xl p-8">
    <!-- Emblema -->
    <div
      class="mb-4 flex h-32 w-32 shrink-0 items-center justify-center rounded-full border-2 border-primary-container/30 bg-surface-container drop-shadow-[0_0_20px_rgba(255,36,228,0.4)]"
    >
      <span
        class="material-symbols-outlined text-primary"
        style="font-size: 64px; font-variation-settings: 'FILL' 1"
        >{{ icon() }}</span
      >
    </div>

    <!-- Título -->
    <h1
      class="neon-glow-pink text-center font-headline-lg text-headline-lg tracking-tight text-primary"
    >
      {{ title() }}
    </h1>

    @if (variant() === 'vitoria') {
      <!-- Chip -->
      <div
        class="mb-6 rounded-lg border border-secondary-fixed/20 bg-secondary-container/10 px-4 py-2"
      >
        <span class="font-label-mono text-label-mono uppercase text-secondary-fixed">{{
          chipLabel
        }}</span>
      </div>
    }

    <!-- Personagem revelado -->
    @if (variant() === 'derrota' && characterName()) {
      <div class="mb-6 flex flex-col items-center gap-1 text-center">
        <p class="font-body-md text-body-md text-on-surface-variant">Seu personagem era</p>
        <p class="font-headline-md text-headline-md text-primary">{{ characterName() }}</p>
      </div>
    }

    <!-- Ações -->
    <div class="flex w-full flex-col gap-4">
      <button
        type="button"
        class="active-press w-full rounded-full bg-secondary-fixed-dim py-4 font-headline-md text-headline-md text-on-secondary shadow-[0_0_15px_rgba(0,219,233,0.4)] transition-transform duration-150 hover:scale-95"
        (click)="playAgain.emit()"
      >
        Jogar Novamente
      </button>
      <button
        type="button"
        class="w-full rounded-full border-2 border-outline-variant bg-transparent py-3 font-body-lg text-body-lg text-on-surface-variant transition-colors duration-150 hover:bg-surface-variant hover:text-on-surface"
        (click)="backToHome.emit()"
      >
        Voltar ao Início
      </button>
    </div>
  </div>
</div>
